import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 100%;
  min-height: 85vh;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Container = styled.div`
  height: 100%;
  width: 100%;
  max-width: 800px;
`
export const MessageContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 0 0 90px 0;
  gap: 36px;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`
